import { render, staticRenderFns } from "./BusinessLicenseSample.vue?vue&type=template&id=ba95df26&"
import script from "./BusinessLicenseSample.vue?vue&type=script&lang=js&"
export * from "./BusinessLicenseSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VDialog,VImg})
